export default {
  home: {
    minute: '分鐘',
    price_info: '{mianfei}分鐘內免費，',
    price_info1: '每日最高收費{currencyName}{fengding}，',
    price_info3: '可退按金{currencyName}{yajin}，預存租借可免按金',
    price_info2: '全月通會籍免按金/免每次租金（48小時內歸還），可循環不限次租借，如單次租借逾期歸還，請繳付普通會員標準租金。',
    price_info4_title: '服務對象及範圍: ',
    price_info4: '只供香港理工大學學生及教職員使用。此充電服務只提供在理工大學校園內租借及歸還。',
    feature_1: '優質鋰電池，電流充沛',
    feature_2: '香港和澳門各租借點皆可通用',
    feature_3: '充電器內置無線充電+三種主流式插頭電線',
    feature_4_title: '使用手續: ',
    feature_4: '請用智能手機(二維碼掃描軟件)掃上二維碼登記手機號碼後，繳付每個充電器的按金{yajin}元。繳付完成後充電器會自動彈出。每次租借可享7天共享充電服務。',
    feature_5_title: '服務費用: ',
    feature_5: '繳付按金後，{currencyName}0 可享7天共享充電服務;逾期7天後歸還充電器，{currencyName}{yajin}元按金不能退還',
    feature_6_title: '退還按金: ',
    feature_6: '歸還充電器後，用戶可用智能手機在充電機的顯示屏上掃二維碼，在閣下賬戶內的錢包，申請退還按金。按金會於最多1個⼯作⽇後，由第三方支付平台原路退還。',
    // tips_1: '餘額不足，需增值滿{currencyName}{yajin}按金才可用',
    tips_1: '未繳按金，需繳按金{currencyName}{yajin}後使用',
    tips_2: '增值按金{currencyName}{yajin}即可租用，用完即可退還',
    tips_3: '當前結餘{currencyName}{myyue}，可以直接租借',
    tips_4: '當前按金{currencyName}{myyajin}，可以直接租借',
    tips_5: '您是全月通會員，可以直接租借',
    submit: '立即充值',
    borrow: '立即租借',
    msg_fail_title: '提示',
    msg_fail_content: '租借失敗，請重新嘗試',
    goborrow: '去租借!!!',
    download_app: '使用APP 下載/打開',
    download: '跳轉至app或應用市場',
    wechat_download_tips: '請點擊右上角在瀏覽器打開下載APP'
  },
  login: {
    code_title: '短信驗證',
    phone_number: '請輸入{0}位數手機號碼',
    verification_code: '請輸入SMS驗證碼',
    captcha_code: '請輸入右側隨機碼',
    send_code: '獲取驗證碼',
    login: '登錄',
    submit: '提交',
    agree: '點擊登錄，表示已閱讀並同意',
    readme: '使用條款',
    msg_fail_login: '登錄失敗',
    msg_success_login: '登錄成功',
    exchangesuccess: '兌換成功',
    msg_success_login_code: '領取成功，請下載APP登錄使用',
    msg_fail_user: '獲取用戶信息出錯，是否重試？',
    sign_in_with: '第三方登錄',
    no_sms: '没收到短信',
    retry: '重新發送',
    receive: '申請領取',
    invite_pwd: '邀請驗證碼',
    couponcode: '請輸入電子券碼',
    vip_agreen_tip: '繼續，表示您接受我們的',
    vip_agreen_service: '服務條款',
    vip_agreen_and: '和',
    vip_agreen_policy: '隱私政策'
  },
  confirm: {
    title: '確認付款',
    pay_label: '需支付',
    auth_label: '預授權',
    price_tips: '充值金額申請提現後1~5天到賬',
    auth_tips: '預授權押金{currencyName}{yajin},歸還後按實際租金扣取',
    pay_type: '請選擇支付方式',
    submit: '確認支付',
    msg_loading: '加載中...',
    msg_fail_title: '提示',
    msg_fail_payment: '發起押金支付失敗',
    msg_fail_order: '創建租借訂單失敗',
    msg_fail_support: '當前環境不支持',
    msg_fail_confirm: '確定',
    msg_fail_payconfirm: '我已支付',
    msg_fail_retry: '重試',
    msg_fail_cancel: '取消',
    支付宝: '支付寳',
    支付宝HK: '支付寳HK',
    银联: '銀聯',
    微信: '微信',
    PayPal: 'PayPal',
    paypalsubmsg: '可使用VISA，萬事達，美國運通及大來信用卡信用卡結帳。'
  },
  mine: {
    title: '個人中心',
    wallet: '錢包/按金',
    deposit: '按金',
    wallet_in: '支付HK$',
    nouse: '不適用',
    wallet_out: '申退按金',
    wallet_log: '充值提現',
    order: '租借訂單',
    coupon: '優惠易',
    coupon_cd: '充電券',
    login_tips: '請先登錄',
    msg_fail_title: '提示',
    msg_fail_update: '修改失敗，請重新嘗試',
    msg_loading: '加載中...',
    msg_fail_user: '獲取用戶信息出錯，是否重試？',
    help: '幫助',
    setting: '設置',
    logout: '退出',
    buy: '購買設備',
    prestore: '全月通會員',
    prestore_tips: '每次任用48小時，香港和澳門通用',
    prestore_tips2: '全年HK$828',
    prestore_type: '已登記',
    prestore_type2: '尚未登記',
    prestore_date: '有效期至',
    prestore_btn: '立即登記',
    single: '單次租借',
    single_tips: '(預先支付按金HK$198)',
    single_tips1: '(只須按金HK$198)',
    single_tips2: '租金6HK$/小時,每天最多收費5小時',
    balance: '餘額',
    paid: '已繳納',
    unpaid: '未繳納',
    using: '使用中',
    deposit_btn: '繳納按金',
    invitation: '邀請碼',
    invite_btn: '邀請朋友',
    wallet_tips: '退按流程：',
    wallet_tips2: '1.點擊"退還按⾦"',
    wallet_tips3: '2.按⾦將於最多1個⼯作⽇退還'
  },
  msg: {
    loading: '加載中...',
    title: '提示',
    success: '操作成功',
    error: '未知異常，請聯繫管理員',
    confirm: '確認',
    retry: '重試',
    cancel: '取消',
    title_fail: '錯誤',
    success_payment: '充值成功',
    success_buy: '購買成功',
    fail_payment: '付款失敗',
    keyword: '關鍵詞',
    unpaid_order: '有未付款的訂單',
    go_pay: '去支付',
    no_more: '沒有更多了',
    payTitle: '購買充電券',
    paySubTitle: '充電券費用',
    payVipTitle: '購買VIP',
    payVipSubTitle: 'VIP費用',
    payYaJinTitle: '繳納按金',
    payYaJinSubTitle: '繳納費用',
    payZuJinTitle: '支付租金',
    confirmpaytip: '長按二維碼保存到微信掃描支付後請按“我已支付”'
  },
  result: {
    title: '確認結果',
    price_plan: '計費規則',
    msg_success: '租借成功',
    msg_tips_loading: '正在彈出充電寶，請耐心等待...',
    msg_result_loading: '正在確認支付結果...',
    msg_fail_confirm: '確定',
    btn_usage: '使用說明',
    btn_return: '歸還說明',
    deposit: '押金',
    msg_fail_content: '請求失敗，請重新嘗試',
    price_label: '/小時',
    price_info: '{mianfei}分鐘內免費，日封頂{fengding}{ccurrency}，計費滿{yajin}{ccurrency}自動扣取押金',
    tips_1: '請按圖取走<span class="number">{number}號</span>位置充電寶',
    tips_2: '歸還請收好按箭頭<span class="highlight">【線朝下方】</span>插入機櫃並鎖',
    msg_note_usage: '充電寶配有三種充電線，請按需使用',
    msg_note_return: '請把充電線插回相應位置後，把充電寶插入機櫃的卡槽中',
    return_info: '整理好充電線，將充電寶插入機櫃空缺位置固定後即可完成歸還。'
  },
  result_msg: {
    loading: '加載中...',
    refresh: '點擊刷新'
  },
  order: {
    title: '租借訂單',
    in_use: '正在使用',
    ended: '已結束',
    msg_error: '加載失敗',
    no_data: '暫無數據'
  },
  order_item: {
    order_number: '訂單號',
    venue_rented: '租借地點',
    time_rented: '租借時間',
    venue_returned: '歸還地點',
    time_returned: '歸還時間',
    charge_standard: '收費標準',
    // charge_standard_info: '每小時{pJifei}{pCurrency}(前{pMian}分鐘免費)',
    charge_standard_info: '全月通收費標準：全月通會籍每次租借48小時免費;普通會員收費標準：每60分鐘內計費6元，每天優惠最多計費30元，每次租借限74小時內歸還付費，逾期將以全部按金抵扣。',
    rent_occurred: '租借費用',
    returned: '已歸還',
    unreturned: '未歸還',
    type_0: '未租借',
    type_1: '租借中',
    type_2: '已撤銷',
    type_3: '已歸還',
    type_4: '有疑問',
    type_5: '超時歸還',
    min: '分',
    unpaid: '未付款',
    payment: '支付租金'
  },
  setting: {
    title: '設置',
    lang: '選擇語言'
  },
  help: {
    title: '幫助'
  },
  wallet_in: {
    title: '增值',
    price_label: '增值金額',
    price_placeholder: '請輸入增值金額',
    balance: '當前結餘',
    price_auto: '預存費用可連續使用, 免除按金{0}',
    price_tips: '點擊確定增值，表示已閱讀並同意',
    price_btn: '《增值條款》',
    submit: '立即續費',
    loading: '加載中...',
    paying: '跳轉到付款頁...',
    msg_title: '提示',
    msg_fail_order: '創建增值訂單失敗',
    msg_fail_payment: '增值支付失敗',
    msg_fail_retry: '重試',
    vip_tips: '登記全月通會員可享任用充電服務',
    price_title: '全月通會員',
    price_title_1: '全月通會員',
    price_title_2: '雙月通會員',
    price_title_3: '全年通貴賓档',
    price_1: '(單月費)',
    price_2: '(雙月費)',
    price_3: '(年費)',
    price_sub_title: '享{0}天免費充電服務',
    vip_title: '會員專享充電禮遇',
    vip_tips1: '每次可免費租借48小時',
    vip_tips2: '全港通用',
    rule_title: '使用規則：',
    rule_tips: '1、全月通每次租借必須於48小時内歸還，才可以繼續享用全港任意租借服務，如租借逾期，需按照普通會員的標準補交租金。\n2、租借逾期5天者，會被取消全月通會員資格，并需補交5天租金。\n3、享受包月服務賬戶每次限使用一件充電器。\n4、此會員服務為指定時段的優惠待遇，如有查詢，請聯絡客戶服務熱綫：852-2322 2956。\n5、如有任何爭議，香港易充電有限公司保留最終決定權。'
  },
  wallet_out: {
    title: '按金退回',
    price_label: '提現金額',
    price_placeholder: '請輸入提現金額',
    balance: '當前餘額',
    balance_all: '全部提取',
    deposit: '押金',
    deposit_tips: '目前有租借中的訂單，押金{pcurrencyName}{pyajin}暫不可退',
    submit: '立即提現',
    apply: '申請提現',
    confirm: '確認',
    loading: '加載中...',
    msg_fail_price: '提現金額不正確',
    msg_fail_balance: '提現金額不能大於當前餘額',
    msg_title: '錯誤',
    msg_success_content: '申請提現成功',
    type1: '原路退回',
    type2: '退至商場',
    type3: '預約退回',
    tips_title: '說明',
    tips1: '退還按金:歸還充電器後，用戶可用智能手機在充電機的顯示屏上掃二維碼，在閣下賬戶內的錢包，申請退還按金。按金會於最多1個工作日後，由第三方支付平台原路退還。',
    tips2: '按金將會退還到您填寫的帳戶中，處理帳戶按金退還需要1-7個工作日，請耐心等待。',
    input1: '香港名牌商城手機號:',
    input2: '銀行卡號:',
    input3: '開戶行支行:',
    input4: '姓名:',
    btn: '提交',
    error_tips: '請輸入完整的信息'
  },
  coupon: {
    title: '優惠易',
    title_cd: '充電券',
    input_tips: '請輸入優惠券碼',
    btn: '領取',
    coupon_type1: '租借優惠券',
    coupon_type2: '商家優惠券',
    deadline: '有效期',
    divide: '至',
    detail: '優惠券詳情',
    instructions: '條款及細則:',
    restrict: '時間限制:',
    tips1: '1. 每張充電券均有顯示充電面值﹐可用以抵扣相應租金。',
    tips2: '2. 當租借完成後﹐系統會提示用戶可使用充電券抵銷相應租金﹐用戶須自行支付剩餘之租借費用。',
    tips3: '3. 每張充電券只能使用一次。',
    tips4: '4. 每次租借只能使用一張充電券。',
    tips5: '5. 此券不能兌換現金、不設找贖﹑不能與其他優惠同時使用。',
    tips6: '6. 如有任何爭議，香港易充電有限公司保留最終決定權',
    code: '券碼',
    category_0: '其　他',
    category_1: '餐飲娛樂',
    category_2: '購物零售',
    category_3: '美容護理',
    coupon_wb_tips: '請在付款前出示本券',
    shop: '門　市',
    coupon_toBeUsed: '待用',
    coupon_buy: '購買',
    coupon_haveBeenUsedOrPastDue: '已使用/已過期',
    coupon_content: '確認購買此充電券嗎？',
    coupon_pay_fee: 'HK$ {0}',
    coupon_paytype_title: '請選擇付款方式',
    coupon_paytype_alipay: '支付寶',
    coupon_paytype_alipayhk: 'AlipayHK',
    coupon_paytype_unionpay: '銀聯支付',
    coupon_pay_button: '確認支付'
  }
}
